import {ApplicationPolicy} from './application_policy';
import {Form, WorkspaceMembershipRole} from '@paperlessio/sdk/api/models';

export class FormPolicy extends ApplicationPolicy {
  record: Form;

  index(): boolean {
    return true;
  }

  show(): boolean {
    return true;
  }

  create(): boolean {
    return this.workspace_membership.at_least(WorkspaceMembershipRole.admin);
  }

  update(): boolean {
    return this.workspace_membership.at_least(WorkspaceMembershipRole.admin);
  }

  destroy(): boolean {
    return this.workspace_membership.at_least(WorkspaceMembershipRole.admin);
  }
}
